<div class="page-container">
    <div class="page-header">
        <div class="header-left">
            <div class="search-input">
                <hugeicons-icon [icon]="searchIcon" [size]="16" color="currentColor"
                    class="search-icon"></hugeicons-icon>
                <input type="text" placeholder="Search attorneys..." [(ngModel)]="searchTerm" (input)="onSearch()">
            </div>
        </div>
        <div class="header-right">
            <button class="btn-primary btn btn-sm" (click)="toggleAdd()">
                <hugeicons-icon [icon]="addIcon" [size]="20" color="currentColor"></hugeicons-icon>
                Add Attorney
            </button>
        </div>
    </div>

    <div class="content-wrapper" [appDynamicHeight]="24">
        <!-- List View -->
        <div class="table-container card">
            @if (attorneys.length > 0) {
            <table class="data-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Attorney Name</th>
                        <th>Contact Preference</th>
                        <th>Contact Info</th>
                        <th>Status</th>
                        <th class="text-right">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of attorneys; track item) {
                    <tr>
                        <td>{{ item.id }}</td>
                        <td>
                            <div class="user-cell">
                                <div class="avatar" [style.background]="getAvatarColor(item.id).bg"
                                    [style.color]="getAvatarColor(item.id).color">
                                    @if (item.profile_image_path) {
                                    <img [src]="item.profile_image_path" [alt]="item.attorney_name">
                                    }
                                    @if (!item.profile_image_path) {
                                    <span>{{ (item.first_name?.charAt(0) || '') + (item.last_name?.charAt(0) || '') ||
                                        'A' }}</span>
                                    }
                                </div>
                                <div class="info">
                                    <span class="name">{{ item.attorney_name }}</span>
                                    <span class="firm">{{ item.firm_name }}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="badge-outline">{{ item.preferred_contact }}</span>
                        </td>
                        <td>
                            <div class="contact-info">
                                <span>{{ item.attorney_email }}</span>
                                <span class="phone">{{ item.attorney_phone }}</span>
                            </div>
                        </td>
                        <td>
                            <span class="status-badge" [class.active]="item.user?.status === 'ACTIVE'"
                                [class.suspended]="item.user?.status !== 'ACTIVE'">
                                {{ item.user?.status === 'ACTIVE' ? 'Active' : 'Inactive' }}
                            </span>
                        </td>
                        <td class="text-right">
                            <app-action-dropdown [actions]="actionsMap.get(item.id!) || []"
                                (actionClick)="handleTableAction($event, item)">
                            </app-action-dropdown>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
            } @else {
            <app-no-data title="No Attorneys Found"
                description="You haven't added any attorneys yet. Click 'Add Attorney' to get started."
                [icon]="noDataIcon">
            </app-no-data>
            }

            <!-- Empty State -->
        </div>

        <!-- Pagination Controls -->
        <app-pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage"
            (pageChange)="onPageChange($event)">
        </app-pagination>
    </div>
</div>

<!-- Modal Component -->
<app-add-attorney [isOpen]="isAdding" [attorney]="selectedAttorney" (close)="toggleAdd()"
    (save)="handleSaveAttorney($event)"></app-add-attorney>